import React, { useState, useEffect } from 'react'
import EditUserDetailsNew from './EditUserDetailsNew.container';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import KarzaPOPUPUI from '../../../../../presentationals/Popup/KarzaPopup.componentNew'
import AAdharPopup from '../../../../../presentationals/Popup/KarzaAddharPopup.componentNew'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import { getAllUserDetailsIncompleteByUserId, panProfileDetails, aadharXmlData, aadharXmlDetails, getDocumentByUserId, getAskForObligorById, reinitateFiByUserID, resendFieldInvestationEmailUserID } from '../../../AdminActionCreator.component';
import { getFiUserDetailsById } from '../../../AdminActionCreator.component';
import EditPersonalDetail from './EditPersonalDetail';
import EditBasicDetail from './EditBasicDetail';
import EditCurrentAddressDetail from './EditCurrentAddressDetail'
import EditPermanentAddressDetail from './EditPermanentAddressDetail'
import EditAssetVehicleDetail from './EditAssetVehicleDetail';
import EditEmploymentDetail from './EditEmploymentDetail';
import EditAccountDetail from './EditAccountDetail';
import EditDouemntsDetails from './EditDocumentDetail'
import EditDealerAgentDetail from './EditDealerAgentDetail'
import { getUserDealerAgentInfoById } from '../../../AdminActionCreator.component';
const customStylePopup = {
    zIndex: '9'
}

const currenPage = 1;
const totalItems = 20;

export default function Main({ userDetails, viewType, admin, PayloadBorrowerId }) {
    const [loader, setLoader] = useState(false)
    const [popups, setpopups] = useState({ show: false, popupStatus: '' })
    const [allData, setAllData] = useState({})
    const [panPopup, setPanPopup] = useState(false)
    const [panData, setpanData] = useState({})
    const [aadhaarPopup, setAadhaarPopup] = useState(false)
    const [aadhaarData, setaadhaarData] = useState({})
    const [aadhaarAddressData, setaadhaarAddressData] = useState("")
    const [aadhaarAddressPopupData, setaadhaarAddressPopupData] = useState("")
    const [verificationType, setverificationType] = useState("")
    const [documentData, setDocumentData] = useState([])
    const [selectedDocument, setSelectedDocument] = useState({})
    const [allDocuments, setallDocuments] = useState([])
    const [agentDealerData, setagentDealerData] = useState({})
    const [editdata, setEditData] = useState({ show: false, type: "", data: {} })
    const [fiDetails, setFiDetails] = useState(null)

    useEffect(() => {
        ApicallFn()
        if (viewType == "borrower") {
            getfi()
        }
    }, [])

    const getfi = () => {
        getFiUserDetailsById(PayloadBorrowerId, callback => {
            setFiDetails(callback?.data ?? {})
        })
    }

    const ApicallFn = () => {
        getAllUserDetailsIncompleteByUserIdFn(PayloadBorrowerId)
        panProfileDetailsFn(PayloadBorrowerId)
        aadharXmlDataFn(PayloadBorrowerId)
        getDocumentByUserIdFn(PayloadBorrowerId)
        getUserDealerAgentInfoByIdFn(PayloadBorrowerId)
    }

    const getUserDealerAgentInfoByIdFn = (id) => {
        getUserDealerAgentInfoById(id, callback => {
            if (callback?.status == 200 && callback?.message == "success") {
                setagentDealerData(callback?.data)
            } else {
                setagentDealerData({})
            }
        })
    }

    const handleLoader = (value) => {
        setLoader(value)
    }

    const getAllUserDetailsIncompleteByUserIdFn = (data) => {
        handleLoader(true)
        getAllUserDetailsIncompleteByUserId(data, callback => {
            handleLoader(false)
            setAllData(callback)
        })
    }

    const panProfileDetailsFn = (data) => {
        handleLoader(true)
        panProfileDetails(data, callback => {
            handleLoader(false)
            setpanData(callback)
        })
    }

    const getDocumentByUserIdFn = (data) => {
        handleLoader(true)
        getDocumentByUserId(currenPage, totalItems, data, callback => {
            handleLoader(false)
            setDocumentData(callback?.data)
            setallDocuments(callback?.data?.documents)
        })
    }

    const aadharXmlDetailsFn = (data, value) => {
        handleLoader(true)
        aadharXmlDetails(data, callback => {
            handleLoader(false)
            setaadhaarAddressPopupData(callback)

            let parsedAddress = null
            if (callback?.address) {
                if (typeof callback.address === 'object') {
                    parsedAddress = callback.address
                } else if (typeof callback.address === 'string') {
                    if (callback.address.includes("{")) {
                        try {
                            parsedAddress = JSON.parse(callback.address)
                        } catch (e) {
                            parsedAddress = null
                        }
                    }
                }
            }

            if (parsedAddress && typeof parsedAddress === 'object') {
                let combined = parsedAddress.combinedAddress
                if (!combined && parsedAddress.splitAddress && typeof parsedAddress.splitAddress === 'object') {
                    const sa = parsedAddress.splitAddress
                    combined = [sa.houseNumber, sa.street, sa.landmark, sa.vtcName, sa.location, sa.subdistrict, sa.district, sa.state, sa.country, sa.pincode].filter(Boolean).join(', ')
                }
                if (!combined) {
                    const parts = [
                        parsedAddress.house || parsedAddress.houseNumber,
                        parsedAddress.street,
                        parsedAddress.landmark,
                        parsedAddress.locality || parsedAddress.location,
                        parsedAddress.subdistrict,
                        parsedAddress.district,
                        parsedAddress.state,
                        parsedAddress.country,
                        parsedAddress.pin || parsedAddress.pincode
                    ].filter(Boolean)
                    if (parts.length > 0) {
                        combined = parts.join(', ')
                    }
                }
                setaadhaarAddressData({
                    ...parsedAddress,
                    combinedAddress: combined || (typeof callback?.address === 'string' ? callback.address : '')
                })
            } else {
                setaadhaarAddressData({
                    combinedAddress: callback?.address || '',
                    rawAddress: callback?.address || '',
                    careOf: callback?.fatherName || ''
                })
            }
            setAadhaarPopup(value)
        })
    }
    const aadharXmlDataFn = (data) => {
        handleLoader(true)
        aadharXmlData(data, callback => {
            handleLoader(false)
            setaadhaarData(callback)
            if (callback?.type == "aadhaar") {
                setverificationType("XML")
            } else if (callback?.type == "digiLocker") {
                setverificationType("Digilocker")
            }
        })
    }

    const closePopup = () => {
        setPanPopup(false)
        setAadhaarPopup(false)
        handleEditdata(false, "", "")
        ApicallFn()
    }

    const handleAadhaarPanPopup = (value, type) => {
        if (type == "pan") {
            setPanPopup(value)
        }
        else if (type == "aadhaar") {
            aadharXmlDetailsFn(PayloadBorrowerId, value)
        }
    }

    const handleDocumentSelected = (e) => {
        console.log("allDocuments", allDocuments)
        const value = e.target.value;
        const ar = allDocuments?.filter((el) => el?.documentUrl === value)
        setSelectedDocument(ar[0])
    }

    const handleEditdata = (show, EditType, EditData) => {
        setEditData({ show: show, type: EditType, data: EditData })
    }

    const handleTextPopup = (type = false, text = "") => {
        setpopups({ show: type, popupStatus: text })
    }

    const closeTextPopup = () => {
        setTimeout(() => {
            handleTextPopup()
        }, 5000)
    }

    const handleAsk = () => {
        setLoader(true)
        getAskForObligorById(PayloadBorrowerId, callback => {
            setLoader(false)
        })
    }

    const handleReinitate = (type) => {
        if (type == "Reinitiate") {
            setLoader(true)
            reinitateFiByUserID(PayloadBorrowerId, callback => {
                setLoader(false)
                if (callback?.status == 200) {
                    handleTextPopup(true, "Fi Reinitiated Successfully!")
                } else {
                    handleTextPopup(true, callback?.data)
                }
                closeTextPopup()
            })
        } else if (type == "Sendmail") {
            setLoader(true)
            resendFieldInvestationEmailUserID(PayloadBorrowerId, callback => {
                setLoader(false)
                if (callback?.status == 200) {
                    handleTextPopup(true, "Mail Send Successfully!")
                } else {
                    handleTextPopup(true, callback?.data)
                }
                closeTextPopup()
            })
        }
    }

    return (
        <>

            {
                loader ? <Loader /> : ''
            }
            {
                popups?.show ? <Popup popupStatus={popups?.popupStatus} closePopup={handleTextPopup} /> : ''
            }

            {
                panPopup ?
                    <KarzaPOPUPUI userDetail={userDetails} karzaData={panData} closePopup={closePopup} customStyle={customStylePopup} />
                    : ''}
            {
                aadhaarPopup ?
                    <AAdharPopup addressData={aadhaarAddressData} karzaData={aadhaarAddressPopupData} closePopup={closePopup} verificationType={verificationType} customStyle={customStylePopup} />
                    : ''}

            {
                editdata?.show ?
                    editdata?.type == "personal" ?
                        <EditPersonalDetail data={editdata?.data}
                            closePopup={closePopup}
                            customStyle={customStylePopup}
                            handleLoader={handleLoader}
                            handleTextPopup={handleTextPopup}
                            closeTextPopup={closeTextPopup}
                            admin={admin}
                        />
                        :
                        editdata?.type == "basic" ?
                            <EditBasicDetail data={editdata?.data}
                                closePopup={closePopup}
                                customStyle={customStylePopup}
                                handleLoader={handleLoader}
                                handleTextPopup={handleTextPopup}
                                closeTextPopup={closeTextPopup}
                                admin={admin}
                            />
                            :
                            editdata?.type == "currentAddress" ?
                                <EditCurrentAddressDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                    admin={admin}
                                />
                                :
                                editdata?.type == "permanentAddress" ?
                                    <EditPermanentAddressDetail data={editdata?.data}
                                        closePopup={closePopup}
                                        customStyle={customStylePopup}
                                        handleLoader={handleLoader}
                                        handleTextPopup={handleTextPopup}
                                        closeTextPopup={closeTextPopup}
                                        admin={admin}
                                    />
                                    :
                                    editdata?.type == "vehicle" ?
                                        <EditAssetVehicleDetail data={editdata?.data}
                                            closePopup={closePopup}
                                            customStyle={customStylePopup}
                                            handleLoader={handleLoader}
                                            handleTextPopup={handleTextPopup}
                                            closeTextPopup={closeTextPopup}
                                            admin={admin}
                                        />
                                        :
                                        editdata?.type == "employment" ?
                                            <EditEmploymentDetail data={editdata?.data}
                                                closePopup={closePopup}
                                                customStyle={customStylePopup}
                                                handleLoader={handleLoader}
                                                handleTextPopup={handleTextPopup}
                                                closeTextPopup={closeTextPopup}
                                                admin={admin}
                                            />
                                            :
                                            editdata?.type == "account" ?
                                                <EditAccountDetail data={editdata?.data}
                                                    closePopup={closePopup}
                                                    customStyle={customStylePopup}
                                                    handleLoader={handleLoader}
                                                    handleTextPopup={handleTextPopup}
                                                    closeTextPopup={closeTextPopup}
                                                    admin={admin}
                                                />
                                                :
                                                editdata?.type == "document" ?
                                                    <EditDouemntsDetails data={editdata?.data}
                                                        closePopup={closePopup}
                                                        customStyle={customStylePopup}
                                                        handleLoader={handleLoader}
                                                        handleTextPopup={handleTextPopup}
                                                        closeTextPopup={closeTextPopup}
                                                        allDocuments={allDocuments}
                                                        admin={admin}
                                                    />
                                                    :
                                                    editdata?.type == "dealerAgent" ?
                                                        <EditDealerAgentDetail data={editdata?.data}
                                                            closePopup={closePopup}
                                                            customStyle={customStylePopup}
                                                            handleLoader={handleLoader}
                                                            handleTextPopup={handleTextPopup}
                                                            closeTextPopup={closeTextPopup}
                                                            admin={admin} PayloadBorrowerId={PayloadBorrowerId}
                                                        />
                                                        :
                                                        ''
                    : ''}

            <EditUserDetailsNew

                allData={allData}
                agentDealerData={agentDealerData}
                handleAadhaarPanPopup={handleAadhaarPanPopup}
                panData={panData}
                aadhaarData={aadhaarData}
                documentData={documentData}
                selectedDocument={selectedDocument}
                handleDocumentSelected={handleDocumentSelected}
                handleEditdata={handleEditdata}
                allDocuments={allDocuments}
                viewType={viewType}
                handleAsk={handleAsk}
                fiDetails={fiDetails}
                handleReinitate={handleReinitate}
            />
        </>
    )
}
